import React, { Fragment } from 'react';
  
  const Out_Of_Credits = ({
    isMobile
  }) =>  {
    return (
        <Fragment>
              
            {/* Heading */}
            <div style={{paddingBottom: '2rem', marginBottom: '2rem', borderBottom: '1px solid rgb(39,39,42)'}}>
                <h1 style={{fontWeight: 'bold', fontSize: '1.5rem', margin: 0}}>
                    Out of Credits
                </h1>
                <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', marginTop: '.5rem'}}>
                    Troubleshoot and resolve credit-related issues.
                </p>
            </div>
            {/* Main content */}
            <div>
                {/* Box Section */}
                <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                    <h2 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                        Quick Fix
                    </h2>
                    <div style={{height: '1.5rem'}}></div>
                    <h2 style={{color: '#fff)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                        Make sure you're subscribed and then press <kbd style={{padding: '.25rem .5rem', margin: '0 3px', fontSize: '.75rem', background: 'rgb(39,39,42)', borderRadius: '.25rem'}}>CTRL + Q</kbd> in the application to close the app, and then re-open it.
                    </h2>
                </div>

                {/* Box Section */}
                <div style={{marginTop: '2rem', padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                    <h2 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                        Other Reasons
                    </h2>
                    <div style={{margin: '1rem 0'}}>
                        {/* Bulleted List Item */}
                        <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.25rem'}}>
                            {/* Bullet point */}
                            <div style={{background: 'rgb(113,113,122)', borderRadius: '50%', width: '.5rem', height: '.5rem'}}></div>
                            {/* Text */}
                            <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                                Your subscription has expired
                            </p>
                        </div>
                        {/* Bulleted List Item */}
                        <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.75rem 0'}}>
                            {/* Bullet point */}
                            <div style={{background: 'rgb(113,113,122)', borderRadius: '50%', width: '.5rem', height: '.5rem'}}></div>
                    
                            {/* Text */}
                            <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                                You've used all available credits for the month
                            </p>
                        </div>
                    </div>
                    {/* Button */}
                    <div style={{marginTop: '1rem'}}>
                        <button style={{boxShadow: '0 0 20px rgba(255, 191, 0, .3)', background: '#FFFF00', fontWeight: 600, fontSize: '.875rem', width: `${isMobile ? '100%' : 'fit-content'}`, marginLeft: 'auto', padding: '.5rem 1rem', borderRadius: '14px', border: 'none'}}>
                            <div style={{display: 'flex', gap: '.5rem', alignItems: 'center', justifyContent: 'center'}}>
                                Upgrade Plan
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
  }
  
  export default Out_Of_Credits;
  